<style lang="stylus">
    .rightPanel{
        position: fixed;
        z-index: 2;
        top: 105px;
        right: 0;
        bottom: 35px;
        user-select:none;
        pointer-events: none;
        .panel-menu{
            position: absolute;
            pointer-events: auto;
            right: 0;
            top: 0;
            width: 50px;
            bottom: 0;
            border-left: 1px solid;
            border-right: 1px solid;
            border-radius: 1px;
            z-index: 1;
            .disabled-link .item-icon{
                opacity: 0.2 !important;
                cursor: not-allowed;
            }
            .panel-menu-menubtn{
                width: 32px;
                height: 30px;
                color: #444;
                text-align: center;
                line-height: 30px;
                font-size: 14px;
                margin: 5px auto;
                user-select: none;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                .item-icon{
                    width: 32px;
                    height: 32px;
                }
                &:hover{
                    background-color: #ddd;
                }
            }
            .panel-menu-menubtn.rotate{
                transform: rotate(180deg)
            }
            .panel-menu-link{
                display: block;
                width: 32px;
                height: 32px;
                user-select: none;
                margin: 14px auto;
                transition: all 0.3s ease-in-out;
                position: relative;
                text-align: center;
                line-height: 30px;
                .item-icon{
                    cursor: pointer;
                    vertical-align: middle;
                    width: 32px;
                    height: 32px;
                    border-radius: $box-radius;
                    color: var(--svg-color-primary)
                    &.active-icon {
                        color: var(--svg-color-active);
                        background: var(--bg-color-side-view-icon);
                    }
                    &:hover:not(.active-icon){
                      background-color: $main-hovercolor;
                    }
                }
                .active-icon{
                    //background-color: $main-selectcolor;
                    cursor initial
                }
            }
            #panel-rightmenu3 {
                .item-icon.active-icon {
                    background: unset !important;
                }
            }
            .panel-option-btn {
                margin: 8px auto;
            }
        }

        .panel-view-area{
            position: absolute;
            pointer-events: auto;
            top: 0;
            bottom: 0;
            transition: transform 0.3s ease-in-out;
            border-left: 1px solid var(--border-color-left-panel);
            transform: scale(1);
            >div{
                height: calc(100% - 40px);
                overflow: auto;
                .panel-view{
                    user-select: none;
                }
            }
        }
    }
</style>
<style lang="stylus">
    .rightPanel
        .panel-normalmenu
            height calc(100% - 60px)
            @media screen and (max-height: 666px)
                height calc(100% - 36px)
                overflow-y auto
                overflow-x hidden
        .panel-menu
            background-color $right-view-menucolor
            border-color var(--border-color-left-panel)
        .panel-view-area
            background-color $right-view-backcolor
            .panel-view-topbar
                height 40px
                background var(--bg-color-side-view)
                padding 0 12px 0 16px
                display flex
                justify-content space-between
                align-items center
                border-bottom 1px solid var(--border-color-left-panel)
                .panel-view-title
                    font-size 14px

                    max-width 200px
                    font-weight 700

                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                    color var(--text-color-primary)
                    display flex
                    align-items center
                    span
                        display block
                        height 13px
                    .back-left-arrow
                        margin-right 4px
                        height 13px
                        width 12px
                        cursor pointer
                .panel-view-btn
                    display flex
                    align-items center
                    >svg
                        width 24px
                        height 24px
                        cursor pointer
                        color var(--svg-color-primary)
                        &:hover
                            background-color var(--bg-color-right-panel-close-icon-hover)
                            border-radius 4px;
                .panel-view-aititle
                    display flex
                    align-items center
                    >img
                        margin-right 4px
                    >p
                        font-size 14px
                        font-weight 700
                        color: var(--text-color-primary);
                        margin-right 4px
                    img
                        display block
                .panel-view-rightbox
                    display flex
                    align-items center
                    .panel-view-pointbox
                        position relative
                        display flex
                        align-items center
                        height 24px
                        padding-left  4px
                        border-radius 4px
                        // background #F2F2F7
                        cursor pointer
                        width 80px
                        border: 1px solid rgba(0, 0, 0, 0.08)
                        .point-icon
                            width 24px
                            height 24px
                        .point-num
                            font-size 12px
                            line-height 16px
                            color #222
                            font-weight 400
                            min-width 40px
                            // margin-right 4px
                        .point-btn
                            width 20px
                            height 20px
                            position absolute
                            right 2px
                            top 2px
                            cursor pointer
                            background #fff
                            border-radius 4px
                            svg
                                width 16px
                                height 16px
                                color #424242
                                margin 2px
                            &:hover
                                background var(--themeColor)
                                svg
                                    color #fff
                    .panel-view-close
                        width 24px
                        height 24px
                        border-radius 4px
                        cursor pointer
                        margin-left 8px
                        svg
                            width 24px
                            height 24px
                        &:hover
                            background rgba(0, 0, 0, .04)
</style>

<template>
    <div ref="rightPanel" class="rightPanel" v-show="expandRight" @click="setActive">
        <div class="panel-menu">
            <div class="panel-normalmenu">
                <div class="panel-menu-menubtn" @click="toggleRightMenu()" :class="{ rotate: showRightPanel }" v-if="false">
                    <iconSymbol class="item-icon" name="toggle"></iconSymbol>
                </div>
                <div
                    :id="'panel-' + item.name"
                    class="panel-menu-link"
                    v-for="(item, key, index) in pics"
                    :key="index"
                    v-show="!disabledViews.includes(key)"
                    @click="itemChosen(key, 'click')"
                    :style="{ margin: `${iconMargin}px auto` }"
                    :content="$t(item.tips)"
                    v-tippy="{ placement: 'left' }"
                    :class="{ 'disabled-link': disabledViews.includes(key) && key != currentView }"
                >
                    <!-- <iconSymbol v-if="currentView==key" class="item-icon" :name="item.activename"></iconSymbol> -->
                    <!-- <iconSymbol class="item-icon" :class="{'active-icon': activeKey === key}" :name="item.name"></iconSymbol> -->
                    <iconSymbol
                        class="item-icon"
                        v-if="key !== 'echart'"
                        :class="{
                            'active-icon': activeKey === key,
                            activeFunc: activeFunc == item.func,
                        }"
                        :name="`rightmenu-${item.svg}${activeKey === key ? '-active' : ''}`"
                    ></iconSymbol>
                </div>
            </div>
            <div class="panel-menu-link panel-option-btn" :content="$t('option')" v-tippy="{ placement: 'left' }" @click="showRightMenuOption">
                <iconSymbol class="item-icon" :class="{ activeFunc: activeFunc == 'rightPanelSetting' }" name="rightmenu-setting"></iconSymbol>
            </div>
        </div>
        <div ref="panelViewArea" :style="{ width: panelW }" class="panel-view-area" id="panelViewArea">
            <!-- <transition name='view-area'> -->
            <div class="panel-view-topbar">
                <p class="panel-view-title">
                    <span @click.stop="editThemeBackTheme" v-if="currentView === 'editTheme'">
                        <iconSymbol name="back-left-arrow" class="back-left-arrow"></iconSymbol>
                    </span>
                    {{ $t(rightPanelTitle) }}
                </p>
                <div class="panel-view-btn">
                    <iconSymbol name="new-rightmenu-close" @click.native="closeRightMenu()" />
                </div>
            </div>
            <keep-alive :exclude="['EChartSet']">
                <!-- <div ref='va'> -->
                <component class="panel-view inner-scrollbar" :is="currentView"></component>
                <!-- </div> -->
            </keep-alive>
            <!-- </transition> -->
        </div>
    </div>
</template>

<script lang="ts">
    declare var getTextEditor: any;
    declare var EDDocument: any;
    declare var ThemeManager: any;
    // import shapeP from "./Common/RightTabs/ShapePanel.vue";
    // import propertyP from "./Common/RightTabs/singleSet/Property.vue";
    // import themeP from "./Common/RightTabs/singleSet/ThemeSet.vue";
    // import layerP from './Common/RightTabs/singleSet/Layers.vue'
    // import layout from './Common/RightTabs/singleSet/GroupLayout.vue'
    // import gantt from './Common/RightTabs/singleSet/GanttSet.vue'
    // import revisions from "./Common/RightTabs/singleSet/revisions.vue";
    // import orgchart from './Common/RightTabs/singleSet/OrgChartSet.vue'
    // import imageset from './Common/RightTabs/singleSet/ImageSet.vue'
    // import pageset from "./Common/RightTabs/singleSet/PageSet.vue";
    // import planset from './Common/RightTabs/singleSet/PlanSet.vue'
    // import mindmaster from './Common/RightTabs/singleSet/MindMaster.vue'
    // import echart from "./Common/RightTabs/complexSet/EChartSet.vue";
    // import tableset from './Common/RightTabs/complexSet/TableSet.vue'
    // import slideset from "./Common/RightTabs/singleSet/SlideSet.vue";
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import checkMindmap from "@/app/utils/checkMindmap.js";
    import aiTips from "@/app/components/ai3/aiTips.vue";
    import { throttle } from "lodash";
    @Component({
        components: {
            shapeP: () => import("./Common/RightTabs/ShapePanel.vue"),
            propertyP: () => import("./Common/RightTabs/singleSet/Property.vue"),
            themeP: () => import("./Common/RightTabs/singleSet/ThemeSet.vue"),
            // layerP,
            // gantt,
            // orgchart,
            echart: () => import("./Common/RightTabs/complexSet/EChartSet.vue"),
            // layout,
            // tableset,
            pageset: () => import("./Common/RightTabs/singleSet/PageSet.vue"),
            // imageset,
            // planset,
            revisions: () => import("./Common/RightTabs/singleSet/revisions.vue"),
            // mindmaster,
            slideset: () => import("./Common/RightTabs/singleSet/SlideSet.vue"),
            aiTips: () => import("@/app/components/ai3/aiTips.vue"),
            remark: () => import("./Common/RightTabs/RemarkList.vue"),
            editTheme: () => import("./Common/RightTabs/singleSet/EditTheme.vue"),
        },
    })
    export default class RightPanel extends Vue {
        pics = {
            shapeP: {
                svg: "style",
                name: "rightmenu1",
                activename: "rightmenu1-blue",
                tips: "rightMenu.tipsList.style",
                func: "showRightStyle",
            },
            pageset: {
                svg: "page",
                name: "rightmenu11",
                activename: "rightmenu11-blue",
                tips: "rightMenu.tipsList.pageset",
                func: "showRightPage",
            },
            themeP: {
                svg: "theme",
                name: "rightmenu3",
                activename: "rightmenu3-blue",
                tips: "rightMenu.tipsList.theme",
                func: "showRightTheme",
            },
            // layerP:{
            //     name: 'rightmenu4',
            //     activename: 'rightmenu4-blue',
            //     tips: 'rightMenu.tipsList.layer',
            //     func: 'showRightLayer'
            // },
            slideset: {
                svg: "ppt",
                name: "rightmenu15",
                activename: "rightmenu15-blue",
                tips: "rightMenu.tipsList.slideset",
                func: "showRightSlide",
            },
            propertyP: {
                svg: "data",
                name: "rightmenu5",
                activename: "rightmenu5-blue",
                tips: "rightMenu.tipsList.attr",
                func: "showRightProperty",
            },
            // imageset:{
            //     name: 'rightmenu2',
            //     activename: 'rightmenu2-blue',
            //     tips: 'rightMenu.tipsList.image',
            //     func: 'showRightImage'
            // },
            // orgchart:{
            //     name: 'rightmenu7',
            //     activename: 'rightmenu7-blue',
            //     tips: 'rightMenu.tipsList.orgchart',
            //     func: 'showRightOrgchart'
            // },
            // planset:{
            //     name: 'rightmenu12',
            //     activename: 'rightmenu12-blue',
            //     tips: 'rightMenu.tipsList.planset',
            //     func: 'showRightPlan'
            // },
            // gantt:{
            //     name: 'rightmenu6',
            //     activename: 'rightmenu6-blue',
            //     tips: 'rightMenu.tipsList.gantt',
            //     func: 'showRightGantt'
            // },
            // mindmaster:{
            //     name: 'rightmenu14',
            //     activename: 'rightmenu14-blue',
            //     tips: 'rightMenu.tipsList.mindmaster',
            //     func: 'showRightMindMaster'
            // },
            revisions: {
                svg: "reversion",
                name: "rightmenu13",
                activename: "rightmenu13-blue",
                tips: "rightMenu.tipsList.revisions",
                func: "showRightHistory",
            },
            // layout:{
            //     name: 'rightmenu10',
            //     activename: 'rightmenu10-blue',
            //     tips: 'rightMenu.tipsList.smartShape',
            //     func: 'showRightSmartshape'
            // },
            // tableset:{
            //     name: 'rightmenu8',
            //     activename: 'rightmenu8-blue',
            //     tips: 'rightMenu.tipsList.table',
            //     func: 'showRightTable'
            // },
            echart: {
                name: "rightmenu9",
                activename: "rightmenu9-blue",
                tips: "rightMenu.tipsList.echart",
                func: "showRightEChart",
            },
        };
        iconMargin: number = 14;
        iconTimer: number = 0;
        rightPanelTitle = "";
        // activeKey: string | null = null; // 用于判断那个菜单有选中，如果用currentView判断，一定会展开右侧面板 x

        get activeKey() {
            return this.$store.state.ui.activeRightPanelKey;
        }

        set activeKey(v) {
            this.$store.commit("setStatus", {
                type: "activeRightPanelKey",
                data: v,
            });
        }
        get showAIPanel() {
            return this.$store.state.ui.showAIPanel;
        }

        itemChosen(key, from) {
            this.$track("rightPanel", "select type", key);
            window["_view"]._tool.endEdit();
            if (this.disabledViews.includes(key)) {
                return;
            }
            this.handleItem(key, from);
        }
        get theme() {
            return this.$store.getters.theme;
        }
        handleItem(key = "", from) {
            if (this.sidePanelAnimationing) return;
            if (this.showAIPanel) {
                this.$bus.$emit("showAIPanel", false);
            }
            if (key == this.currentView) {
                // 使用AI表格/图表分析时，切换不同分析内容不应该关闭侧边栏
                this.closeRightMenu();
                return;
            } else {
                if (!this.showRightPanel) {
                    // 关闭面板时，展开右侧面板
                    !this.focusModeExpandRight && this.$bus.$emit("focusExpandPanel", 1);
                    this.expandAnimation(key);
                    this.toggleRightMenu();
                } else {
                    this.expandAnimation(key);
                }
            }

            this.isEChartData = key === "echart";

            if (key == "shapeP" || key == "echart") {
                this.rightPanelTitle = "";
            }

            if (key == "themeP" || key == "mindmaster") {
                let showEditTheme = key == "themeP" && from !== "other" && !this.theme && !window.EDCONFIG.IS_SDK;

                if (!this.themeLoadedStatus) {
                    this.themeLoadedStatus = 1;
                    this.$store.dispatch("loadConfig", ["ThemeXml.tar", "mmThemes.tar", "markData.tar"]).then((e) => {
                        let arr = [];
                        let p1 = new Promise((res) => {
                            ThemeManager.load(this.lang).then(() => {
                                window["_view"].generateThemesIcon();
                                window["_view"].generateThemeConnectorsIcon();
                                res(true);
                            });
                        });
                        let hasMindmap = window["_view"]?._activePage?.hasMindmap();

                        let p2 = new Promise((res) => {
                            if (hasMindmap) {
                                EDDocument.s_markSheet.loadMarkData().then(() => {
                                    res(true);
                                });
                            } else {
                                res(true);
                            }
                        });
                        arr.push(p1);
                        arr.push(p2);
                        Promise.all(arr).then((e) => {
                            this.themeLoadedStatus = 2;
                            this.currentView = showEditTheme ? "editTheme" : key;
                        });
                    });
                } else if (this.themeLoadedStatus == 2) {
                    this.currentView = showEditTheme ? "editTheme" : key;
                    this.activeKey = key;
                } else if (this.themeLoadedStatus == 1) {
                    this.$store.dispatch("loadConfig", ["ThemeXml.tar", "mmThemes.tar", "markData.tar"]).then((e) => {
                        this.currentView = showEditTheme ? "editTheme" : key;
                        this.activeKey = key;
                    });
                }
            } else if (key == "editTheme") {
                this.currentView = key;
                this.activeKey = "themeP";
            } else {
                this.currentView = key;
                this.activeKey = key;
            }
            this.activeFunc = "";
            this.sensors.track("clickMenu", {
                Catalogues: "rightMenu Bar",
                menu_type: this.currentView,
                popup_source: from,
            });
        }
        toggleRightMenu() {
            window["_view"]._tool.endEdit();
            this.$track("rightPanel", "toggle rightPanel", !this.showRightPanel);
            this.$store.commit("setStatus", {
                type: "showRightPanel",
                data: !this.showRightPanel,
            });
            if (this.currentView === "slideset") {
                this.$bus.$emit("slideToggle", this.showRightPanel);
            }
            // this.$nextTick(() => {
            //     window["_view"].onsize();
            // });
        }
        async closeRightMenu() {
            await this.foldAnimation(this.currentView);
            this.$store.commit("setStatus", {
                type: "showRightPanel",
                data: false,
            });
            this.sensors.track("clickClosure", {
                Catalogues: "rightMenu Bar",
                menu_type: this.currentView,
            });
            // this.currentView = null;
            this.activeKey = null;
            this.$nextTick(() => {
                window["_view"].onsize();
                this.currentView = null;
            });

            if (this.currentView === "remark") {
                this.$store.commit("setStatus", {
                    type: "isRemarkView",
                    data: false,
                });
            }
        }

        showRightMenuOption() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "RightMenuOption",
            });
            this.activeFunc = "";
        }
        setSceneRight(num) {
            this.$store.commit("setStatus", {
                type: "sceneRight",
                data: num,
            });
        }
        isTable(e) {
            this.isTableData = e;
        }
        isEChart(e) {
            this.isEChartData = e;
        }
        setIconMargin(e) {
            clearTimeout(this.iconTimer);
            this.iconTimer = setTimeout(() => {
                let rightPanel = this.$refs.rightPanel as HTMLElement;
                if (!rightPanel) return;
                let arr = Object.keys(this.pics);
                let count = arr.length + 1,
                    winH = window.innerHeight,
                    parentT = rightPanel.getBoundingClientRect()["y"],
                    rotateH = 37,
                    iconH = 32;
                this.iconMargin = 14;
                while (37 + count * (32 + 2 * this.iconMargin) > winH - parentT && this.iconMargin != 0) {
                    this.iconMargin -= 2;
                    this.iconMargin = this.iconMargin < 0 ? 0 : this.iconMargin;
                }
            }, 300);
        }
        // 页面中有思维导图时打开提示

        get isMMPage() {
            return this.$store.state.page.isMMPage;
        }
        get isMMCenter() {
            return this.$store.state.page.isMMCenter;
        }
        get expandRight() {
            return this.$store.getters.expandRight;
        }
        get chartType() {
            return this.$store.state.echart.chartType;
        }
        get isTimeline() {
            return this.$store.state.ui.layoutData.isTimeline;
        }
        get isActionPlanCard() {
            return this.$store.state.ui.layoutData.isActionPlanCard;
        }
        get isActionPlanContainer() {
            return this.$store.state.ui.layoutData.isActionPlanContainer;
        }
        get panelW() {
            if (this.currentView === "tableset" && this.isTableData) {
                this.setSceneRight(550);
                return "500px";
            } else if (this.currentView === "echart" && this.isEChartData) {
                this.setSceneRight(455);
                return "405px";
            } else {
                if (this.showRightPanel) {
                    this.setSceneRight(310);
                    return "260px";
                } else {
                    this.setSceneRight(50);
                    return "0";
                }
            }
        }
        get contentLeft() {
            if (this.currentView === "tableset" && this.isTableData) {
                return this.showRightPanel ? "-550px" : "-50px";
            } else if (this.currentView === "echart" && this.isEChartData) {
                return this.showRightPanel ? "-455px" : "-50px";
            } else {
                return this.showRightPanel ? "-310px" : "-50px";
            }
        }
        get hiddenRightViewList() {
            return this.$store.state.ui.hiddenRightViewList;
        }
        set hiddenRightViewList(v) {
            this.$store.commit("setStatus", {
                type: "hiddenRightViewList",
                data: v,
            });
        }
        get activeShapeType() {
            return this.$store.state.shape.type;
        }
        get disabledViews() {
            let list = JSON.parse(JSON.stringify(this.hiddenRightViewList));
            if (this.$store.state.shape.isActived) {
                if (this.activeShapeType == "Gantt" && list.indexOf("gantt") != -1) {
                    list.splice(list.indexOf("gantt"), 1);
                } else if ((this.activeShapeType == "EDChart" || this.activeShapeType == "EChartItem") && list.indexOf("echart") != -1) {
                    if (!(this.chartType == "map" && !this.internal)) {
                        list.splice(list.indexOf("echart"), 1);
                    }
                } else if (this.isSmartShape && list.indexOf("layout") != -1) {
                    list.splice(list.indexOf("layout"), 1);
                } else if (this.activeShapeType == "Table" && list.indexOf("tableset") != -1) {
                    list.splice(list.indexOf("tableset"), 1);
                } else if (this.activeShapeType == "OrgShape" && list.indexOf("orgchart") != -1) {
                    list.splice(list.indexOf("orgchart"), 1);
                }
            }
            return list;
        }
        get isSmartShape() {
            return this.$store.state.ui.layoutData.layoutEdit;
        }
        get showRightPanel() {
            return this.$store.state.ui.showRightPanel;
        }
        get menuRight() {
            if (this.showRightPanel) return this.$store.state.ui.sceneRight - 50 + "px";
            else return "0";
        }
        get currentView() {
            if (this.activeKey === "echart") {
                (this.chartType == "map" && (this.pics.echart.name = "rightmenu16")) || (this.pics.echart.name = "rightmenu9"); // 更新右侧icon
            }
            return this.$store.state.ui.currentView;
        }
        set currentView(v) {
            this.$store.state.ui.currentView = v;
        }
        get isTableData() {
            return this.$store.state.ui.isTableData;
        }
        set isTableData(v) {
            this.$store.commit("setStatus", {
                type: "isTableData",
                data: v,
            });
        }
        get isEChartData() {
            return this.$store.state.ui.isEChartData;
        }
        set isEChartData(v) {
            this.$store.commit("setStatus", {
                type: "isEChartData",
                data: v,
            });
        }
        get themeLoadedStatus() {
            return this.$store.state.ui.themeLoadedStatus;
        }
        get clipathLoadedStatus() {
            return this.$store.state.ui.clipathLoadedStatus;
        }
        set themeLoadedStatus(v) {
            this.$store.commit("setStatus", {
                type: "themeLoadedStatus",
                data: v,
            });
        }
        set clipathLoadedStatus(v) {
            this.$store.commit("setStatus", {
                type: "clipathLoadedStatus",
                data: v,
            });
        }
        get shapeType() {
            return this.$store.state.shape.type;
        }
        get sidePanelAnimationing() {
            return this.$store.state.ui.sidePanelAnimationing;
        }
        set sidePanelAnimationing(v) {
            this.$store.commit("setStatus", {
                type: "sidePanelAnimationing",
                data: v,
            });
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        set activeFunc(v) {
            this.$store.commit("setStatus", {
                type: "activeFunc",
                data: v,
            });
        }
        updatePositionAnimation(dom, type, startRight, endRight, duration = 400) {
            this.sidePanelAnimationing = true;
            this.$bus.$emit("ft_closeChildExpand"); // 关闭浮动工具栏弹窗
            let start;
            let resolve = null;
            let updatePosition = (dom, type, data) => {
                dom.style[type] = `${data}px`;
            };
            let easeOutExpo = (t, b, c, d) => {
                return t == d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b;
            };
            const resizeFunc = throttle(() => {
                window["_view"].onsize();
            }, 120);
            let step = (timestamp) => {
                !start && (start = timestamp);
                const stepp = Math.min((timestamp - start) / duration, 1);
                const changeRight = easeOutExpo(stepp, startRight, endRight - startRight, 1);
                // const changeRight = startRight + stepp * (endRight - startRight);
                updatePosition(dom, type, changeRight);
                if (stepp != 1) {
                    resizeFunc();
                    // window["_view"].onsize();
                    window.requestAnimationFrame(step);
                } else {
                    resizeFunc();
                    // window["_view"].onsize();
                    setTimeout(() => {
                        // 避开触发scroll事件
                        resolve();
                        this.sidePanelAnimationing = false;
                    }, 30);
                }
            };
            return new Promise((s) => {
                resolve = s;
                window.requestAnimationFrame(step);
            });
        }
        getPreLeft(view, action) {
            const show = action == "expand";
            if (view === "tableset" && this.isTableData) {
                return show ? -550 : -50;
            } else if (view === "echart" && this.isEChartData) {
                return show ? -455 : -50;
            } else {
                return show ? -310 : -50;
            }
        }
        expandAnimation(key) {
            let dom = this.$refs.panelViewArea as HTMLElement,
                endData = this.getPreLeft(key, "expand"),
                startData = parseInt(this.contentLeft);

            if (endData == startData) {
                return;
            }
            this.$bus.$emit("sidePanelAnimation", "right", -startData, -endData);
            return this.updatePositionAnimation(dom, "left", startData, endData);
        }
        foldAnimation(key) {
            let dom = this.$refs.panelViewArea as HTMLElement,
                startData = parseInt(this.contentLeft),
                endData = this.getPreLeft(key, "fold");

            if (startData == endData) {
                return;
            }
            this.$bus.$emit("sidePanelAnimation", "right", -startData, -endData);
            return this.updatePositionAnimation(dom, "left", startData, endData);
        }

        // ai3
        get userInfo() {
            return this.$store.state.userInfo || this.$store.state.user.userInfo;
        }
        get aiConsumePointsVisble() {
            return this.$store.state.staticConfig.aiConsumePointsVisble;
        }
        get aiConsumePointsText() {
            return this.$store.state.staticConfig.aiConsumePointsText;
        }

        get focusModeExpandRight() {
            return this.$store.getters.expandRight;
        }
        editThemeBackTheme() {
            let ts: any = this;
            ts.$bus.$emit("rightPanelBackTheme");
        }

        @Watch("shapeType")
        WatchShapeType(nv, ov) {
            if ((nv != "EDChart" || nv != "EChartItem") && this.currentView == "echart") {
                if (this.focusModeExpandRight) {
                    this.foldAnimation(this.currentView);
                }
                this.$store.commit("setStatus", {
                    type: "showRightPanel",
                    data: false,
                });
                this.activeKey = null;
                this.$nextTick(() => {
                    window["_view"].onsize();
                    this.currentView = null;
                });
            }
        }
        @Watch("isEChartData")
        WatchisEChartData(newv, oldv) {
            this.$nextTick(() => {
                window["_view"].onsize();
            });
        }
        @Watch("isTableData")
        WatchisTableData(newv, oldv) {
            this.$nextTick(() => {
                window["_view"].onsize();
            });
        }
        @Watch("isMMPage")
        watchMMShape(val) {
            if (val && this.currentView == "themeP") {
                checkMindmap();
            }
        }
        @Watch("currentView")
        watchCurrentView(val) {
            if (val == "themeP" && this.isMMPage) {
                checkMindmap();
            }
        }

        setActive() {
            this.$store.commit("setStatus", {
                type: "activePanel",
                data: "right",
            });
        }

        mounted() {
            this.setIconMargin("");
            window.addEventListener("resize", this.setIconMargin);
            this.$bus.$on("itemChosen", (key, from) => {
                this.itemChosen(key, from);
            });
        }
        created() {
            if (this.isPlugin) {
                delete this.pics.slideset;
                delete this.pics.propertyP;
                delete this.pics.revisions;
            }
            let list = localStorage.getItem("rightViewList");
            this.hiddenRightViewList = list ? JSON.parse(list) : ["echart"];
            let ts: any = this;
            ts.$bus.$on("changeRightViewActiveKey", (type: string) => {
                if (type) {
                    this.activeKey = type;
                }
            });
            ts.$bus.$on("changeRightView", (type: string, force: boolean = false, from) => {
                let view = window["_view"];
                if (type == "echart" && this.chartType == "map" && !this.internal) {
                    console.log("block");
                    return;
                }
                // this.currentView = null;
                this.handleItem(type, from);
                if (force) {
                    ts.$store.commit("setStatus", {
                        type: "showRightPanel",
                        data: true,
                    });
                }
                if (type) {
                    this.$nextTick(() => {
                        if (type === "tableset") {
                            if (view._tool._editingCell) {
                                if (getTextEditor() && getTextEditor()._contentDiv) {
                                    getTextEditor()._contentDiv.focus();
                                }
                            }
                        }
                        if (this.showRightPanel && this.isTableData && type != "tableset") {
                            this.isTableData = false;
                        }
                    });
                }
            });
            ts.$bus.$on("changeRightType", (data) => {
                if (data["type"] == "table") {
                    this.isTable(data["data"]);
                } else {
                    this.isEChart(data["data"]);
                }
            });
            ts.$bus.$on("setRightViewTitle", (str: string) => {
                this.rightPanelTitle = str;
            });
            if (this.editTeamOption) {
                delete this.pics.revisions;
            }
        }
        get editTeamOption() {
            return this.$store.state.ui.editTeamOption;
        }

        beforeDestroy() {
            let ts: any = this;
            window.removeEventListener("resize", this.setIconMargin);
            ts.$bus.$off("changeRightView");
            ts.$bus.$off("changeRightType");
            ts.$bus.$off("setRightViewTitle");
        }
    }
</script>
<i18n>
{
  "zh": {
    "rightMenu": {
      "tipsList": {
        "style": "样式",
        "image": "图片",
        "theme": "主题",
        "layer": "图层",
        "attr": "形状数据",
        "gantt": "甘特图",
        "orgchart": "组织结构图",
        "table": "表格",
        "echart": "图表",
        "smartShape": "图形",
        "timeline": "时间线",
        "pageset": "页面设置",
        "planset": "平面图",
        "revisions": "历史版本",
        "mindmaster": "思维导图",
        "slideset": "文档演示",
        "actionplanCard": "路线图卡片",
        "actionplanContainer": "路线图容器"
      }
    },
    "historyTips": "最新版本历史功能将会在你每编辑后的三分钟自动生成历史版本文件，当然也支持您手动创建，再也不用担心文件丢啦~",
    "confirm": "知道了",
    "option": "设置",
    "fill": "填充",
    "pageSet": "页面设置",
    "themeSet": "主题",
    "layerSet": "图层",
    "slideSet": "幻灯片",
    "propertySet": "数据属性",
    "imageSet": "图片",
    "orgchartSet": "组织结构图",
    "planSet": "平面图",
    "ganttSet": "甘特图",
    "mmSet": "思维导图",
    "revisionSet": "历史版本",
    "tableSet": "表格",
    "chartSet": "编辑数据",
    "smartshapeSet": "图形",
    "pointToast": "AI智能助手已完成本次指令，消耗了%used%点AI点数",
    "aiTitle": "亿图AI",
    "pointBuy": "点数充值",
    "editTheme": "自定义主题",
    "editCustomTitle": "编辑主题"
  },
  "en": {
    "rightMenu": {
      "tipsList": {
        "style": "Style",
        "image": "Image",
        "theme": "Theme",
        "layer": "Layer",
        "attr": "Data Property",
        "gantt": "Gantt Chart",
        "orgchart": "Org Chart",
        "table": "Table",
        "echart": "Chart",
        "smartShape": "Smart Shape",
        "timeline": "Timeline",
        "pageset": "Page Settings",
        "planset": "Floor Plan",
        "revisions": "Historical Version",
        "mindmaster": "MindMap",
        "slideset": "Slide",
        "actionplanCard": "Card",
        "actionplanContainer": "Column"
      }
    },
    "historyTips": "The latest save function enables to  auto-save your file every three minutes after you edit it, or you can save the file manually. You will never worry about losing files! ",
    "confirm": "Know",
    "option": "Option",
    "fill": "Fill",
    "pageSet": "Page",
    "themeSet": "Theme",
    "layerSet": "Layers",
    "slideSet": "Slides",
    "propertySet": "Data Propertits",
    "imageSet": "Image",
    "orgchartSet": "Organization Chart",
    "planSet": "Floor Plan",
    "ganttSet": "Gantt Chart",
    "mmSet": "Mind Map",
    "revisionSet": "Historical Version",
    "tableSet": "Table",
    "chartSet": "Manage Data",
    "smartshapeSet": "Smart Shape",
    "pointToast": "The AI smart assistant has followed the instruction and used %used% AI points",
    "aiTitle": "Edraw AI",
    "pointBuy": "Top up your credits",
    "editTheme": "Edit",
    "editCustomTitle": "Custom Theme"
  },
  "fr": {
    "rightMenu": {
      "tipsList": {
        "style": "Style",
        "image": "Image",
        "theme": "Thème",
        "layer": "Couche",
        "attr": "Propriété de données",
        "gantt": "Diagramme de Gantt",
        "orgchart": "Organigramme",
        "table": "Table",
        "echart": "Graphique",
        "smartShape": "Graphique",
        "timeline": "chronologie",
        "pageset": "Paramètres de Page",
        "planset": "Plan d'étage",
        "revisions": "Version Historique",
        "mindmaster": "Carte Mentale",
        "slideset": "Présentation du document",
        "actionplanCard": "Carte",
        "actionplanContainer": "Colonne"
      }
    },
    "historyTips": "La fonction historique de la dernière version générera automatiquement un fichier de version historique toutes les trois minutes après la modification. Bien sûr, vous pouvez également le créer manuellement. Ainsi, vous n'avez plus à vous soucier de la perte de fichiers ",
    "confirm": "J'ai compris",
    "option": "Paramètres",
    "fill": "Remplir",
    "pageSet": "Mise en page",
    "themeSet": "Thème",
    "layerSet": "Calques",
    "slideSet": "Diaporama",
    "propertySet": "Attribut",
    "imageSet": "Image",
    "orgchartSet": "Organigramme",
    "planSet": "Plan d'étage",
    "ganttSet": "Diagramme de Gantt",
    "mmSet": "Carte Mentale",
    "revisionSet": "Version historique",
    "tableSet": "Tableau",
    "chartSet": "éditer les données",
    "smartshapeSet": "Forme intelligente",
    "pointToast": "L'assistant IA a suivi les instructions et utilisé %used% points IA",
    "aiTitle": "IA Edraw",
    "pointBuy": "Compléter vos crédits",
    "editTheme": "Thème personnalisé",
    "editCustomTitle": "Modifier"
  },
  "de": {
    "rightMenu": {
      "tipsList": {
        "style": "Format",
        "image": "Bild",
        "theme": "Thema",
        "layer": "Ebene",
        "attr": "Dateneigenschaft",
        "gantt": "Gannt-Diagramm",
        "orgchart": "Organigramm",
        "table": "Tabelle",
        "echart": "Diagramm",
        "smartShape": "Grafik",
        "timeline": "Zeitleiste",
        "pageset": "Seiteneinstellung",
        "planset": "Grundriss",
        "revisions": "Historische Version",
        "mindmaster": "Mind Map",
        "slideset": "Diashow",
        "actionplanCard": "Karte",
        "actionplanContainer": "Spalte"
      }
    },
    "historyTips": "Die neueste Versionsverlaufsfunktion generiert automatisch alle drei Minuten nach dem Bearbeiten eine Verlaufsversionsdatei. Natürlich können Sie sie auch manuell erstellen, sodass Sie sich keine Sorgen mehr über den Verlust von Dateien haben. ",
    "confirm": "Ich habs",
    "option": "Einstellungen",
    "fill": "füllen",
    "pageSet": "Seite",
    "themeSet": "Thema",
    "layerSet": "Ebenen",
    "slideSet": "Folien",
    "propertySet": "Dateneigenschaften",
    "imageSet": "Bild",
    "orgchartSet": "Organigramm",
    "planSet": "Grundriss",
    "ganttSet": "Gantt-Diagramm",
    "mmSet": "Mind Map",
    "revisionSet": "Historische Version",
    "tableSet": "Tabelle",
    "chartSet": "Daten verwalten",
    "smartshapeSet": "Smart Shape",
    "pointToast": "AI Smart Assistant hat die Anweisung ausgeführt und dafür %used% AI-Punkte verwendet",
    "aiTitle": "Edraw AI",
    "pointBuy": "Guthaben auffüllen",
    "editTheme": "Benutzerdefiniertes Design ",
    "editCustomTitle": "Bearbeiten"
  },
  "jp": {
    "rightMenu": {
      "tipsList": {
        "style": "スタイル",
        "image": "画像",
        "theme": "テーマ",
        "layer": "レイヤ",
        "attr": "属性",
        "gantt": "ガントチャート",
        "orgchart": "組織図",
        "table": "フォーム",
        "echart": "チャート",
        "smartShape": "図形",
        "timeline": "タイムライン",
        "pageset": "ページ設定",
        "planset": "間取り図",
        "revisions": "前のバージョン",
        "mindmaster": "マインドマップ",
        "slideset": "プレゼンテーション",
        "actionplanCard": "カード",
        "actionplanContainer": "コラム"
      }
    },
    "historyTips": "最新のバージョン履歴機能を使用すると、ファイルを編集した後、3分ごとに自動保存することも、手動で保存することも可能です。ファイル紛失の心配はありません。",
    "confirm": "了解",
    "option": "設定",
    "fill": "塗りつぶし",
    "pageSet": "ページ設定",
    "themeSet": "テーマ",
    "layerSet": "レイヤー",
    "slideSet": "スライドショー",
    "propertySet": "プロパティ",
    "imageSet": "図形",
    "orgchartSet": "組織図",
    "planSet": "間取り図",
    "ganttSet": "ガントチャート",
    "mmSet": "マインドマップ",
    "revisionSet": "バージョン履歴",
    "tableSet": "テーブル",
    "chartSet": "データを編集",
    "smartshapeSet": "図形",
    "pointToast": "AIスマートアシスタントは指示に従い、%used%AIポイントを使用しました",
    "aiTitle": "Edraw AI",
    "pointBuy": "クレジットを補充",
    "editTheme": "カスタムテーマ",
    "editCustomTitle": "編集"
  },
  "es": {
    "rightMenu": {
      "tipsList": {
        "style": "Estilo",
        "image": "Imagen",
        "theme": "Tema",
        "layer": "Capa",
        "attr": "Propiedad de los datos",
        "gantt": "Gráfico de Gantt",
        "orgchart": "Organigráma",
        "table": "Mesa",
        "echart": "Gráfico",
        "smartShape": "Forma inteligente",
        "timeline": "cronología",
        "pageset": "Configuración de la página",
        "planset": "Plano de la planta",
        "revisions": "Versión histórica",
        "mindmaster": "Mapa mental",
        "slideset": "Diapositiva",
        "actionplanCard": "Tarjeta",
        "actionplanContainer": "Columna"
      }
    },
    "historyTips": "La función de historial de la última versión generará automáticamente un archivo del historial de versión cada tres minutos después de que lo edites. Por supuesto, también puedes crearlo manualmente, para que no tengas que preocuparte más por perder archivos ~",
    "confirm": "Entiendo",
    "option": "Configuración",
    "fill": "llenar",
    "pageSet": "Página",
    "themeSet": "Tema",
    "layerSet": "Capas",
    "slideSet": "Diapositivas",
    "propertySet": "Data Propertits",
    "imageSet": "Imagen",
    "orgchartSet": "Organigrama",
    "planSet": "Plano de la planta",
    "ganttSet": "Gráfico de Gantt",
    "mmSet": "Mapa mental",
    "revisionSet": "Versión histórica",
    "tableSet": "Mesa",
    "chartSet": "Administrar datos",
    "smartshapeSet": "Forma inteligente",
    "pointToast": "El asistente inteligente de IA ha seguido la instrucción y ha utilizado %used% puntos de IA",
    "aiTitle": "IA de Edraw",
    "pointBuy": "Recarga tus créditos",
    "editTheme": "Tema personalizado",
    "editCustomTitle": "Editar"
  },
  "pt": {
    "rightMenu": {
      "tipsList": {
        "style": "Estilo",
        "image": "Imagem",
        "theme": "Tema",
        "layer": "Camada",
        "attr": "Propriedade de Dados",
        "gantt": "Gráfico de Gantt",
        "orgchart": "Organograma",
        "table": "Tabela",
        "echart": "Gráfico",
        "smartShape": "Forma Inteligente",
        "timeline": "Linha do tempo",
        "pageset": "Configurações de Página",
        "planset": "Planta",
        "revisions": "Versão Histórica",
        "mindmaster": "MindMaster",
        "slideset": "Slide",
        "actionplanCard": "Card",
        "actionplanContainer": "Coluna"
      }
    },
    "historyTips": "O recurso de histórico da última versão gerará automaticamente um arquivo de histórico três minutos após cada edição, e é claro que você pode criá-lo manualmente, para que não tenha mais que se preocupar em perder arquivos.",
    "confirm": "Entendi",
    "fill": "Preencher",
    "option": "Configuração",
    "pageSet": "Página",
    "themeSet": "Tema",
    "layerSet": "Camadas",
    "slideSet": "Slides",
    "propertySet": "Propriedades dos Dados",
    "imageSet": "Imagem",
    "orgchartSet": "Organograma",
    "planSet": "Planta",
    "ganttSet": "Gráfico de Gantt",
    "mmSet": "MindMaster",
    "revisionSet": "Versão Histórica",
    "tableSet": "Tabela",
    "chartSet": "Gerir Dados",
    "smartshapeSet": "Forma Inteligente",
    "pointToast": "O assistente inteligente de IA seguiu as instruções e usou os pontos de IA %used%",
    "aiTitle": "IA do Edraw",
    "pointBuy": "Aumente seus créditos",
    "editTheme": "Tema personalizado",
    "editCustomTitle": "Editar"
  },
  "it": {
    "rightMenu": {
      "tipsList": {
        "style": "Stile",
        "image": "Immagine",
        "theme": "Tema",
        "layer": "Livello",
        "attr": "Proprietà Dati",
        "gantt": "Diagramma di Gantt",
        "orgchart": "Organigramma",
        "table": "Tabella",
        "echart": "Diagramma",
        "smartShape": "Smart Shape",
        "pageset": "Impostazioni Pagina",
        "planset": "Planimetria",
        "revisions": "Cronologia Versioni",
        "mindmaster": "Mappatura Mentale",
        "slideset": "Diapositiva",
        "actionplanCard": "Carta",
        "actionplanContainer": "Colonna"
      }
    },
    "historyTips": "La funzione di Storia dell'ultima versione genererà automaticamente un file di versione storica ogni tre minuti dopo la modifica. Ovviamente, puoi anche crearlo manualmente. Quindi non devi più preoccuparti di perdere i file ~",
    "confirm": "Fatto",
    "option": "Impostazione",
    "fill": "Riempire",
    "pageSet": "Pagina",
    "themeSet": "Tema",
    "layerSet": "Livelli",
    "slideSet": "Diapositive",
    "propertySet": "Proprietà Dati",
    "imageSet": "Immagine",
    "orgchartSet": "Organigramma",
    "planSet": "Planimetria",
    "ganttSet": "Diagramma di Gantt",
    "mmSet": "Mappatura Mentale",
    "revisionSet": "Cronologia Versioni",
    "tableSet": "Tavolo",
    "chartSet": "Gestisci Dati",
    "smartshapeSet": "Smart Shape",
    "pointToast": "L'assistente AI ha seguito l'istruzione e ha utilizzato %used% punti AI",
    "aiTitle": "Edraw AI",
    "pointBuy": "Ricarica i tuoi crediti",
    "editTheme": "Tema personalizzato",
    "editCustomTitle": "Modifica"
  },
  "tw": {
    "rightMenu": {
      "tipsList": {
        "style": "樣式",
        "image": "圖片",
        "theme": "主題",
        "layer": "圖層",
        "attr": "形狀數據",
        "gantt": "甘特圖",
        "orgchart": "組織結構圖",
        "table": "表格",
        "echart": "圖表",
        "smartShape": "圖形",
        "timeline": "時間線",
        "pageset": "頁面設置",
        "planset": "平面圖",
        "revisions": "歷史版本",
        "mindmaster": "心智圖",
        "slideset": "檔案演示",
        "actionplanCard": "卡片",
        "actionplanContainer": "列"
      }
    },
    "historyTips": "最新版本歷史功能將會在你每編輯後的三分鐘自動建立歷史版本文件，當然也支持您手動建立，再也不用擔心文件丟啦~",
    "confirm": "知道了",
    "option": "設定",
    "fill": "填充",
    "pageSet": "頁面設置",
    "themeSet": "主題",
    "layerSet": "圖層",
    "slideSet": "幻燈片",
    "propertySet": "數據屬性",
    "imageSet": "圖片",
    "orgchartSet": "組織結構圖",
    "planSet": "平面圖",
    "ganttSet": "甘特图",
    "mmSet": "心智圖",
    "revisionSet": "歷史版本",
    "tableSet": "表格",
    "chartSet": "編輯數據",
    "smartshapeSet": "圖形",
    "pointToast": "AI 智慧助理已按照指示運作，並已使用 %used%個 AI 點數",
    "aiTitle": "Edraw AI",
    "pointBuy": "加值點數",
    "editTheme": "自定义主题",
    "editCustomTitle": "编辑主题"
  },
  "kr": {
    "rightMenu": {
      "tipsList": {
        "style": "스타일",
        "image": "이미지",
        "theme": "주제",
        "layer": "도층",
        "attr": "형상 데이터",
        "gantt": "간트도",
        "orgchart": "조직구조도",
        "table": "표",
        "echart": "도표",
        "smartShape": "도형",
        "timeline": "타임라인",
        "pageset": "페이지 설정",
        "planset": "평면도",
        "revisions": "과거 버전",
        "mindmaster": "마인드맵",
        "slideset": "슬라이드",
        "actionplanCard": "로드맵 카드",
        "actionplanContainer": "로드맵 용기"
      }
    },
    "historyTips": "최신 저장 기능을 사용하면 파일을 편집한 후 3분마다 자동 저장하거나 수동으로 파일을 저장할 수 있습니다. 파일을 잃어버릴 염려가 전혀 없습니다!",
    "confirm": "알겠습니다 ",
    "option": "옵션",
    "fill": "채우기",
    "pageSet": "페이지 설정",
    "themeSet": "테마",
    "layerSet": "레이어",
    "slideSet": "슬라이드",
    "propertySet": "데이터 속성",
    "imageSet": "이미지",
    "orgchartSet": "조직도",
    "planSet": "평면도",
    "ganttSet": "간트 차트",
    "mmSet": "마인드맵",
    "revisionSet": "역사 버전",
    "tableSet": "표",
    "chartSet": "데이터 편집",
    "smartshapeSet": "도형",
    "pointToast": "AI 스마트 Assistant가 지침을 따르고 AI %used% 포인트를 사용했습니다.",
    "aiTitle": "Edraw AI",
    "editTheme": "自定义主题",
    "editCustomTitle": "编辑主题"
  }
}
</i18n>
